import React from 'react'

import SearchBarForm from '../../components/searchBar/searchBarForm'
import SearchBarInput from '../../components/searchBar/searchBarInput'

const PageOffLeftSearchBar = ({ location }) => {
  return (
    <div className='off-canvas-left__search'>
      <SearchBarForm location={location}>
        <div style={{margin: 0, padding: 0, display: 'inline'}} />
        <div className='search-field -border-none'>
          <div className='search-field__input'>
            <SearchBarInput value={location.query.term} className='search-field__input-field' name='term' placeholder='Search' />
          </div>
          <button className='fds-c-button search-field__button' type='submit'>
            <i className='e-icon -icon-search'><span className='e-icon__alt'>Search</span></i>
          </button>
        </div>
      </SearchBarForm>
    </div>
  )
}

export default PageOffLeftSearchBar



// WEBPACK FOOTER //
// ./client/components/pageOffCanvasLeft/pageOffLeftSearchBar.js